const mensajes = {
    'FormularioDocumento.Titulo': 'Document',
    'FormularioDocumento.CambiarEtapa': 'Change stage',
    'FormularioDocumento.CampoCodigoDocumentoBase.Nombre': 'Base doc. code',
    'FormularioDocumento.CampoTipoDocumentoId.Nombre': 'Document type',
    'FormularioDocumento.CampoEtapaId.Nombre': 'Stage',
    'FormularioDocumento.CampoProveedorId.Nombre': 'Supplier',
    'FormularioDocumento.CampoCodigoDocumento.Nombre': 'Code',
    'FormularioDocumento.CampoDireccionEntrega.Nombre': 'Delivery address',
    'FormularioDocumento.CampoFechaEntrega.Nombre': 'Delivery date',
    'FormularioDocumento.CampoCondicionComercial.Nombre': 'Commercial condition',
    'FormularioDocumento.CampoBodegaOrigen.Nombre': 'Origin warehouse',
    'FormularioDocumento.CampoBodegaDestino.Nombre': 'Destination warehouse',
    'FormularioDocumento.CampoDocumentoRelacionado.Nombre': 'Related doc.',
    'FormularioDocumento.CampoObservacion.Nombre': 'Observation',
    'FormularioDocumento.CampoClienteId.Nombre': 'Client',
    "FormularioDocumento.DescargarDocumento": 'View PDF',
    "FormularioDocumento.SinRegistros": 'No records found',
    "FormularioDocumento.CampoDocumentoRelacionado.NumeroTicket":"Ticket Number",
    'FormularioDocumento.CampoObservacion.NúmeroGuia': 'Guide Number',
    "boton.agregarDocumentos": 'Add documents',

};

export default mensajes;
